import { render, staticRenderFns } from "./WhyUse.vue?vue&type=template&id=fad94c74&"
import script from "./WhyUse.vue?vue&type=script&lang=js&"
export * from "./WhyUse.vue?vue&type=script&lang=js&"
import style0 from "./WhyUse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports